import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import {reducers} from 'linksoft';

function isDebugEnabled() {
    if(process.env.NODE_ENV === `development`) return true;
    // const debug = localStorage && localStorage.debug;
    // if(typeof debug === 'string') {
    //     return !!debug.split(',').find(x => x === '*' || x === 'app:*' || x === 'app:redux');
    // }
    return false;
}

export default () => {
    let middleware = [thunk];
    if (isDebugEnabled()) {
        let logger = createLogger();
        middleware.push(logger);
    }

    const finalCreateStore  = compose(
        applyMiddleware(...middleware)
    )(createStore);
    const rootReducer = combineReducers(reducers.get());
    return finalCreateStore(rootReducer);
}


// WEBPACK FOOTER //
// ./App/config/store.js